// Obtener la imagen de valoración
export const getStars = (rating: number): string => {
  let number: number;
  if (rating < 5) {
    number = Math.round(rating * 2) / 2;
  }
  else {
    number = 5;
  }
  return require(`@/assets/images/Ratings/Rating_${number}.svg`);
};